import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Remonte en haut de page à chaque changement de route.
 *
 * L'app n'en avait aucune : en scrollant en bas des Collaborateurs puis en
 * cliquant « Tableau de bord » dans la barre latérale, on arrivait au milieu de
 * la page suivante. Le navigateur conserve la position, c'est à l'application
 * de la réinitialiser sur une navigation.
 *
 * On ignore le changement de `search` seul (filtres, onglets) pour ne pas
 * arracher l'utilisateur à sa lecture quand il change un filtre.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}
